import { render, staticRenderFns } from "./TratamientoUbicacionCorporal.vue?vue&type=template&id=4ef50ace"
import script from "./TratamientoUbicacionCorporal.vue?vue&type=script&lang=ts"
export * from "./TratamientoUbicacionCorporal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports